<template>
  <App
    left-arrow
    title="Prospects"
    @click-right="onClickRight"
    class="allSearch"
  >
    <Tabs
      v-model="tabActive"
      slot="extra"
      @change="tableChange"
    >
      <Tab
        :title="$i.title"
        v-for="$i in tabsData"
        :key="$i.label"
        :name="$i.label"
      >
      </Tab>
    </Tabs>
    <PullRefresh
      @refresh="onRefresh"
      v-model="loading"
    >
      <List
        v-model="loading"
        :immediate-check="false"
        :error.sync="error"
        :finished="finished"
        :finished-text="total === 0 ? 'No data!' : 'No more items.!'"
        error-text="Loading failed. Click to retry"
        @load="Onload"
      >
        <CardItem
          v-for="$items in list"
          :key="$items.id"
          :cardInfo="$items"
          :type="tabActive"
        />
      </List>
    </PullRefresh>
  </App>
</template>

<script>
import dayjs from 'dayjs'
import { debounce } from 'lodash-es'
import { Tab, Tabs, PullRefresh, List, Toast } from 'vant'
import { tabsData } from './attr.js'
import { oppTodayalist, oppCloseDate, oppUnorderList, hibernateList } from '@/api/follow/index'
import CardItem from './components/card/index'
import '@/style/vant-patch.less'
import './index.less'
export default {
  name: 'businessOpportunitiesFollowUp',
  data () {
    return {
      showResult: false,
      hasDate: true,
      loading: false,
      finished: false,
      error: false,
      radioVal: '1',
      list: [],
      tabActive: this.$route.query.tabName,
      tabsData: [],
      page: 1,
      size: 10,
      total: 0,
      oppStatus: []
    }
  },
  components: {
    Tab,
    Tabs,
    CardItem,
    List,
    PullRefresh,
  },
  methods: {
    getData: debounce(function () {
      if (this.finished) return
      switch (this.tabActive) {
        case 'followUp':
          this.getTodayList()
          break;
        case 'closeDate':
          this.getoppCloseDate()
          break;
        case 'unsettled':
          this.getoppUnorderList()
          break;
        case 'dormancy':
          this.gethibernateList()
          break;
      }
    }, 600, { leading: true, trailing: false }),
    // 获取状态
    getStatus () {
      this.oppStatus = this.$storage.get('baseData')['opp_status']
    },
    // 状态以及时间转码
    statusAndTimeChange (data) {
      data.forEach(el => {
        this.oppStatus.forEach(item => {
          if (el.status === item.value) {
            el.status = item.key
          }
        })
        el['qbsFollowupTime'] = dayjs(el['qbsFollowupTime']).format('YYYY/MM/DD') || ''
        el['createtime'] = dayjs(el['createtime']).format('YYYY/MM/DD HH:mm:ss') || ''
        if (el.closedate) {
          el.closedate = dayjs(el.closedate).format('YYYY/MM/DD') || ''
        }
      })
    },
    // 今日待跟进
    async getTodayList () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await oppTodayalist({
          'page': this.page,
          'size': this.size,
          'currentIdentity': this.$route.query.currentIdentity
        })
        Toast.clear()
        if (res && res.success) {
          this.statusAndTimeChange(res.data.records)
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error);
        this.error = true
        this.loading = false
      }
    },
    // closedata
    async getoppCloseDate () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await oppCloseDate({
          'page': this.page,
          'size': this.size,
          'currentIdentity': this.$route.query.currentIdentity
        })
        Toast.clear()
        if (res && res.success) {
          this.statusAndTimeChange(res.data.records)
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error)
        this.error = true
        this.loading = false
      }
    },
    // 89天未成交
    async getoppUnorderList () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await oppUnorderList({
          'page': this.page,
          'size': this.size,
          'currentIdentity': this.$route.query.currentIdentity
        })
        Toast.clear()
        if (res && res.success) {
          this.statusAndTimeChange(res.data.records)
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error);
        this.error = true
        this.loading = false
      }
    },
    // 休眠
    async gethibernateList () {
      try {
        /* Toast.loading({
          message: 'Loading...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true
        }) */
        const res = await hibernateList({
          'page': this.page,
          'size': this.size,
          'currentIdentity': this.$route.query.currentIdentity
        })
        Toast.clear()
        if (res && res.success) {
          this.statusAndTimeChange(res.data.records)
          this.total = res.data.total
          this.list = [...this.list, ...res.data.records]
          if (this.list.length === res.data.total) {
            this.finished = true
          } else {
            this.page++
          }
          this.error = false
          this.loading = false
        } else {
          this.error = true
          this.loading = false
          Toast(res.msg)
        }
      } catch (error) {
        Toast.clear()
        console.log(error);
        this.error = true
        this.loading = false
      }
    },
    tableChange () {
      this.page = 1
      this.list = []
      this.total = 0
      this.finished = false
      this.loading = false
      this.getData()
    },
    // 下拉刷新
    onRefresh () {
      this.page = 1
      this.finished = false
      this.list = []
      this.total = 0
      this.getData()
    },
    Onload () {
      this.getData()
      this.loading = false
    },
    init () {
      this.page = 1
      this.list = []
      this.total = 0
      this.finished = false
      this.loading = false
      this.getStatus()
      this.tabsData = tabsData
      this.tabActive = this.$route.query.tabName
      this.getData()
    },
    onClickRight () {
      this.showResult = false
    }
  },
  mounted () {
    this.init()
  }
}
</script>